import 'es6-promise-polyfill';
import Vue from 'vue';
import App from './App';
import ElementUI from 'element-ui';
import timer from './common/Timer';

import 'element-ui/lib/theme-chalk/index.css';

import loader from '@/common/loader';
import RouteKey from '@/common/RouteKey';
import router, { RouteMapper } from '@/router';
import MessageBox from '@/components/common/message-box';

Vue.use(ElementUI);
Vue.config.productionTip = false;
Vue.prototype.loading = function(text) {
  return this.$loading({
    lock: true,
    text: text || 'Loading',
    spinner: 'el-icon-loading',
    background: 'rgba(0, 0, 0, 0.7)'
  });
};
function createRouteConstant() {
  let mapper = {};

  for (let name in RouteKey) {
    if (RouteKey.hasOwnProperty(name)) {
      let route = RouteMapper[RouteKey[name]];
      if (route == null) {
        continue;
      }
      mapper[name] = route.path;
    }
  }
  return {
    route: mapper
  };
}
Vue.prototype.$alert = MessageBox.alert;
Vue.prototype.$confirm = MessageBox.confirm;
Vue.prototype.$loader = loader;
Vue.prototype.$timer = timer;
Vue.prototype.$const = createRouteConstant();
/* eslint-disable no-new */
new Vue({
  el: '#app',
  template: '<App/>',
  components: { App },
  router
});



// WEBPACK FOOTER //
// ./src/main.js